import type { Validate } from 'react-hook-form';

import isEmpty from '@tinkoff/utils/is/empty';
import isString from '@tinkoff/utils/is/string';
import trim from '@tinkoff/utils/string/trim';

const pattern = /^[\s,()./'’\-a-zA-Z0-9]+$/;

const defaultText =
  'Use only letters, numbers, spaces, or symbols , ( ) . / ’ -';

export const latinTextValidator: Validate<unknown, unknown> = (value) => {
  if (isString(value) && !isEmpty(value) && !pattern.test(trim(value))) {
    return defaultText;
  }

  return undefined;
};
